import { Theme } from '@mui/material'

const useStyles = {
  infoLinks: (theme: Theme) => ({
    marginTop: theme.spacing(2),
    color: theme.palette.ui.blueTextColor,
  }),
  loginFooter: (theme: Theme) => ({
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(5),
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      margin: '0 auto',
    },
  }),
}

export default useStyles
